module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  if( alignRightBI.contains(factoryKey)){ 
    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Text</span></div>\r\n<div class=\"row\" >\r\n    <div id=\"propStyleFont\" class=\"style-text prop-detail\"></div>\r\n</div>\r\n<div class=\"row\">\r\n    <div id=\"propStyleColors\" class=\"style-colors col-md-8 \" style=\"padding-left: 0px; padding-right: 0px\"></div>\r\n    <div id=\"propStyleTextStyle\" class=\"style-text col-md-4\" style=\"text-align: right;\"></div>\r\n</div>\r\n")
    ;  }else{ 
    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Text</span></div>\r\n<div class=\"row\" >\r\n    <div id=\"propStyleFont\" class=\"style-text prop-detail\"></div>\r\n</div>\r\n<div class=\"row\">\r\n    <div id=\"propStyleTextStyle\" class=\"style-text prop-detail\"></div>\r\n</div>\r\n<div class=\"row\">\r\n    <div id=\"propStyleColors\" class=\"style-colors\"></div>\r\n</div>\r\n")
    ;  } 
    ; __append("\r\n")
  }
  return __output;

}